import axiosInstance from '../app/axios';

export const adminAPI = {
  // Users
  getUsers: async () => {
    const response = await axiosInstance.get('/admin/users');
    return response.data;
  },

  // Orders
  getOrders: async () => {
    const response = await axiosInstance.get('/admin/orders');
    return response.data;
  },

  updateOrderStatus: async (orderId, status) => {
    const response = await axiosInstance.patch(`/admin/orders/${orderId}/status`, { status });
    return response.data;
  },

  getCoworkerStats: async () => {
    const response = await axiosInstance.get('/admin/coworker-stats');
    return response.data;
  },

  resetCoworkerStats: async () => {
    const response = await axiosInstance.post('/admin/coworker-stats/reset');
    return response.data;
  },

  getMainPage: async () => {
    const response = await axiosInstance.get('/admin/main-page');
    return response.data;
  },

  updateMainPage: async (mainPage) => {
    const response = await axiosInstance.patch('/admin/main-page', { mainPage });
    return response.data;
  },

  deleteOrders: async (orderIds) => {
    const response = await axiosInstance.delete('/admin/orders', {
      data: { orderIds },
    });
    return response.data;
  },

  // Products
  getProducts: async () => {
    const response = await axiosInstance.get('/admin/products');
    return response.data;
  },

  createProduct: async (productData) => {
    const response = await axiosInstance.post('/admin/products', productData);
    return response.data;
  },

  updateProduct: async (productId, updates) => {
    const response = await axiosInstance.patch(`/admin/products/${productId}`, updates);
    return response.data;
  },

  deleteProduct: async (productId) => {
    const response = await axiosInstance.delete(`/admin/products/${productId}`);
    return response.data;
  },

  // Site settings
  getSettings: async (settingsPassword = '') => {
    const response = await axiosInstance.get('/admin/settings', {
      headers: settingsPassword ? { 'x-settings-password': settingsPassword } : undefined,
    });
    return response.data;
  },

  updateSettings: async (patch, settingsPassword = '') => {
    const response = await axiosInstance.patch('/admin/settings', patch, {
      headers: settingsPassword ? { 'x-settings-password': settingsPassword } : undefined,
    });
    return response.data;
  },

  uploadImage: async ({ fileName, base64 }) => {
    const response = await axiosInstance.post('/admin/upload', { fileName, base64 });
    return response.data;
  },
};

export default adminAPI;
